import {
  ChatByTypeGroupDocument,
  ChatByTypeGroupQuery,
  ChatByTypeGroupQueryVariables,
  ChatByTypePrivateDocument,
  ChatByTypePrivateQuery,
  ChatByTypePrivateQueryVariables,
  PrivateChatFragment,
  ChatFragment,
  ChatInsertUserDocument,
  ChatInsertUserMutation,
  ChatInsertUserMutationVariables,
  ChatMessageReadDocument,
  ChatMessageReadMutation,
  ChatMessageReadMutationVariables,
  ChatMessagesDocument,
  ChatMessagesQuery,
  ChatMessagesQueryVariables,
  ChatParticipantsPrivateDocument,
  ChatParticipantsPrivateQuery,
  ChatParticipantsPrivateQueryVariables,
  //LatestChats
  LatestChatsQuery,
  LatestChatsQueryVariables,
  LatestChatsDocument,
} from '../types';
import { client } from '../../client';

export async function getGroupChats(): Promise<Array<ChatFragment>> {
  try {
    const result = await client.mutate<ChatByTypeGroupQuery, ChatByTypeGroupQueryVariables>({
      mutation: ChatByTypeGroupDocument,
      fetchPolicy: 'network-only',
    });
    return result.data.chats;
  } catch (error) {
    throw Error(error);
  }
}

export async function getPrivateChats(): Promise<Array<PrivateChatFragment>> {
  try {
    const result = await client.query<ChatByTypePrivateQuery, ChatByTypePrivateQueryVariables>({
      query: ChatByTypePrivateDocument,
      fetchPolicy: 'network-only',
    });
    return result.data.chats;
  } catch (error) {
    throw Error(error);
  }
}
// teacherMessagesQuery
export async function getChatMessages(variables: ChatMessagesQueryVariables): Promise<Readonly<ChatMessagesQuery>> {
  try {
    const result = await client.mutate<ChatMessagesQuery, ChatMessagesQueryVariables>({
      mutation: ChatMessagesDocument,
      variables,
      fetchPolicy: 'network-only',
    });
    return result.data;
  } catch (error) {
    throw Error(error);
  }
}

// teacherReadConversationMessagesMutation
export async function readMessage(variables: ChatMessageReadMutationVariables): Promise<Readonly<number>> {
  try {
    const result = await client.mutate<ChatMessageReadMutation, ChatMessageReadMutationVariables>({
      mutation: ChatMessageReadDocument,
      variables,
    });
    return result.data.update_chat_message_reads.affected_rows;
  } catch (error) {
    throw Error(error);
  }
}

// teacherReadConversationMessagesMutation
export async function createChatPrivate(variables: ChatInsertUserMutationVariables): Promise<Readonly<string>> {
  try {
    const result = await client.mutate<ChatInsertUserMutation, ChatInsertUserMutationVariables>({
      mutation: ChatInsertUserDocument,
      variables,
    });
    return result.data.insert_chat_user_one.chat.id;
  } catch (error) {
    throw Error(error);
  }
}

export async function getChatWithParticipant(variables: ChatParticipantsPrivateQueryVariables): Promise<Readonly<string>> {
  try {
    const result = await client.mutate<ChatParticipantsPrivateQuery, ChatParticipantsPrivateQueryVariables>({
      mutation: ChatParticipantsPrivateDocument,
      variables,
    });
    return result.data.chat_user[0]?.chat.id;
  } catch (error) {
    throw Error(error);
  }
}

export async function getLatestChats(variables: LatestChatsQueryVariables): Promise<Readonly<LatestChatsQuery>> {
  try {
    const result = await client.query<LatestChatsQuery, LatestChatsQueryVariables>({
      query: LatestChatsDocument,
      variables,
    });
    return result.data;
  } catch (error) {
    throw Error(error);
  }
}
